// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v7.35.0
// source: rfq.proto
/* eslint-disable */
import { BinaryReader, BinaryWriter } from '@bufbuild/protobuf/wire'

import { OrderSide, orderSideFromJSON, orderSideToJSON } from './common/trading'
import { TradeVenue, tradeVenueFromJSON, tradeVenueToJSON } from './common/types'

export const protobufPackage = 'rfq'

/**
 * Which RFQ network a frame, accept or cancel belongs to, WITHIN DERIBIT-
 * SETTLED FLOW. This field is meaningful only once the consumer has already
 * established the venue (from account_id / trade_venue) as Deribit; on any
 * other venue (e.g. Derive) 0 means "not applicable", not "Deribit" — Derive
 * has its own RFQ implementation, unrelated to this Deribit/Paradigm split.
 *
 * UNSPECIFIED is not "unknown" — prost decodes an absent field to 0, so every
 * historical rfq_events row and every frame from an un-upgraded binary reads
 * as 0. Within Deribit flow, consumers MUST treat 0 as Deribit-native — that
 * migration property is load-bearing and must never weaken. Never renumber.
 */
export enum RfqNetwork {
  RFQ_NETWORK_UNSPECIFIED = 0,
  RFQ_NETWORK_DERIBIT = 1,
  RFQ_NETWORK_PARADIGM = 2,
  UNRECOGNIZED = -1,
}

export function rfqNetworkFromJSON(object: any): RfqNetwork {
  switch (object) {
    case 0:
    case 'RFQ_NETWORK_UNSPECIFIED':
      return RfqNetwork.RFQ_NETWORK_UNSPECIFIED
    case 1:
    case 'RFQ_NETWORK_DERIBIT':
      return RfqNetwork.RFQ_NETWORK_DERIBIT
    case 2:
    case 'RFQ_NETWORK_PARADIGM':
      return RfqNetwork.RFQ_NETWORK_PARADIGM
    case -1:
    case 'UNRECOGNIZED':
    default:
      return RfqNetwork.UNRECOGNIZED
  }
}

export function rfqNetworkToJSON(object: RfqNetwork): string {
  switch (object) {
    case RfqNetwork.RFQ_NETWORK_UNSPECIFIED:
      return 'RFQ_NETWORK_UNSPECIFIED'
    case RfqNetwork.RFQ_NETWORK_DERIBIT:
      return 'RFQ_NETWORK_DERIBIT'
    case RfqNetwork.RFQ_NETWORK_PARADIGM:
      return 'RFQ_NETWORK_PARADIGM'
    case RfqNetwork.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * Where a cross-network accept has got to. Paradigm accepts are asynchronous:
 * the HTTP ack means "accepted for processing", and finality arrives later on
 * the trades channel as FILLED or REJECTED. SENT covers that window, during
 * which no other network may be accepted.
 */
export enum RfqAcceptIntentState {
  RFQ_ACCEPT_INTENT_STATE_UNSPECIFIED = 0,
  /** RFQ_ACCEPT_INTENT_STATE_SENT - published; no finality yet */
  RFQ_ACCEPT_INTENT_STATE_SENT = 1,
  /** RFQ_ACCEPT_INTENT_STATE_PENDING - venue acknowledged, awaiting clearing */
  RFQ_ACCEPT_INTENT_STATE_PENDING = 2,
  UNRECOGNIZED = -1,
}

export function rfqAcceptIntentStateFromJSON(object: any): RfqAcceptIntentState {
  switch (object) {
    case 0:
    case 'RFQ_ACCEPT_INTENT_STATE_UNSPECIFIED':
      return RfqAcceptIntentState.RFQ_ACCEPT_INTENT_STATE_UNSPECIFIED
    case 1:
    case 'RFQ_ACCEPT_INTENT_STATE_SENT':
      return RfqAcceptIntentState.RFQ_ACCEPT_INTENT_STATE_SENT
    case 2:
    case 'RFQ_ACCEPT_INTENT_STATE_PENDING':
      return RfqAcceptIntentState.RFQ_ACCEPT_INTENT_STATE_PENDING
    case -1:
    case 'UNRECOGNIZED':
    default:
      return RfqAcceptIntentState.UNRECOGNIZED
  }
}

export function rfqAcceptIntentStateToJSON(object: RfqAcceptIntentState): string {
  switch (object) {
    case RfqAcceptIntentState.RFQ_ACCEPT_INTENT_STATE_UNSPECIFIED:
      return 'RFQ_ACCEPT_INTENT_STATE_UNSPECIFIED'
    case RfqAcceptIntentState.RFQ_ACCEPT_INTENT_STATE_SENT:
      return 'RFQ_ACCEPT_INTENT_STATE_SENT'
    case RfqAcceptIntentState.RFQ_ACCEPT_INTENT_STATE_PENDING:
      return 'RFQ_ACCEPT_INTENT_STATE_PENDING'
    case RfqAcceptIntentState.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum RfqQuoteSide {
  RFQ_QUOTE_SIDE_UNSPECIFIED = 0,
  RFQ_QUOTE_SIDE_BID = 1,
  RFQ_QUOTE_SIDE_ASK = 2,
  UNRECOGNIZED = -1,
}

export function rfqQuoteSideFromJSON(object: any): RfqQuoteSide {
  switch (object) {
    case 0:
    case 'RFQ_QUOTE_SIDE_UNSPECIFIED':
      return RfqQuoteSide.RFQ_QUOTE_SIDE_UNSPECIFIED
    case 1:
    case 'RFQ_QUOTE_SIDE_BID':
      return RfqQuoteSide.RFQ_QUOTE_SIDE_BID
    case 2:
    case 'RFQ_QUOTE_SIDE_ASK':
      return RfqQuoteSide.RFQ_QUOTE_SIDE_ASK
    case -1:
    case 'UNRECOGNIZED':
    default:
      return RfqQuoteSide.UNRECOGNIZED
  }
}

export function rfqQuoteSideToJSON(object: RfqQuoteSide): string {
  switch (object) {
    case RfqQuoteSide.RFQ_QUOTE_SIDE_UNSPECIFIED:
      return 'RFQ_QUOTE_SIDE_UNSPECIFIED'
    case RfqQuoteSide.RFQ_QUOTE_SIDE_BID:
      return 'RFQ_QUOTE_SIDE_BID'
    case RfqQuoteSide.RFQ_QUOTE_SIDE_ASK:
      return 'RFQ_QUOTE_SIDE_ASK'
    case RfqQuoteSide.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum RfqQuoteExecutionInstruction {
  RFQ_QUOTE_EXECUTION_INSTRUCTION_UNSPECIFIED = 0,
  RFQ_QUOTE_EXECUTION_INSTRUCTION_ANY_PART_OF = 1,
  RFQ_QUOTE_EXECUTION_INSTRUCTION_ALL_OR_NONE = 2,
  UNRECOGNIZED = -1,
}

export function rfqQuoteExecutionInstructionFromJSON(object: any): RfqQuoteExecutionInstruction {
  switch (object) {
    case 0:
    case 'RFQ_QUOTE_EXECUTION_INSTRUCTION_UNSPECIFIED':
      return RfqQuoteExecutionInstruction.RFQ_QUOTE_EXECUTION_INSTRUCTION_UNSPECIFIED
    case 1:
    case 'RFQ_QUOTE_EXECUTION_INSTRUCTION_ANY_PART_OF':
      return RfqQuoteExecutionInstruction.RFQ_QUOTE_EXECUTION_INSTRUCTION_ANY_PART_OF
    case 2:
    case 'RFQ_QUOTE_EXECUTION_INSTRUCTION_ALL_OR_NONE':
      return RfqQuoteExecutionInstruction.RFQ_QUOTE_EXECUTION_INSTRUCTION_ALL_OR_NONE
    case -1:
    case 'UNRECOGNIZED':
    default:
      return RfqQuoteExecutionInstruction.UNRECOGNIZED
  }
}

export function rfqQuoteExecutionInstructionToJSON(object: RfqQuoteExecutionInstruction): string {
  switch (object) {
    case RfqQuoteExecutionInstruction.RFQ_QUOTE_EXECUTION_INSTRUCTION_UNSPECIFIED:
      return 'RFQ_QUOTE_EXECUTION_INSTRUCTION_UNSPECIFIED'
    case RfqQuoteExecutionInstruction.RFQ_QUOTE_EXECUTION_INSTRUCTION_ANY_PART_OF:
      return 'RFQ_QUOTE_EXECUTION_INSTRUCTION_ANY_PART_OF'
    case RfqQuoteExecutionInstruction.RFQ_QUOTE_EXECUTION_INSTRUCTION_ALL_OR_NONE:
      return 'RFQ_QUOTE_EXECUTION_INSTRUCTION_ALL_OR_NONE'
    case RfqQuoteExecutionInstruction.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum RfqState {
  RFQ_STATE_UNSPECIFIED = 0,
  RFQ_STATE_OPEN = 1,
  RFQ_STATE_FILLED = 2,
  RFQ_STATE_CANCELLED = 3,
  RFQ_STATE_EXPIRED = 4,
  UNRECOGNIZED = -1,
}

export function rfqStateFromJSON(object: any): RfqState {
  switch (object) {
    case 0:
    case 'RFQ_STATE_UNSPECIFIED':
      return RfqState.RFQ_STATE_UNSPECIFIED
    case 1:
    case 'RFQ_STATE_OPEN':
      return RfqState.RFQ_STATE_OPEN
    case 2:
    case 'RFQ_STATE_FILLED':
      return RfqState.RFQ_STATE_FILLED
    case 3:
    case 'RFQ_STATE_CANCELLED':
      return RfqState.RFQ_STATE_CANCELLED
    case 4:
    case 'RFQ_STATE_EXPIRED':
      return RfqState.RFQ_STATE_EXPIRED
    case -1:
    case 'UNRECOGNIZED':
    default:
      return RfqState.UNRECOGNIZED
  }
}

export function rfqStateToJSON(object: RfqState): string {
  switch (object) {
    case RfqState.RFQ_STATE_UNSPECIFIED:
      return 'RFQ_STATE_UNSPECIFIED'
    case RfqState.RFQ_STATE_OPEN:
      return 'RFQ_STATE_OPEN'
    case RfqState.RFQ_STATE_FILLED:
      return 'RFQ_STATE_FILLED'
    case RfqState.RFQ_STATE_CANCELLED:
      return 'RFQ_STATE_CANCELLED'
    case RfqState.RFQ_STATE_EXPIRED:
      return 'RFQ_STATE_EXPIRED'
    case RfqState.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum RfqMakerQuoteState {
  RFQ_MAKER_QUOTE_STATE_UNSPECIFIED = 0,
  /** RFQ_MAKER_QUOTE_STATE_OPEN - live on the venue */
  RFQ_MAKER_QUOTE_STATE_OPEN = 1,
  RFQ_MAKER_QUOTE_STATE_FILLED = 2,
  RFQ_MAKER_QUOTE_STATE_CANCELLED = 3,
  RFQ_MAKER_QUOTE_STATE_EXPIRED = 4,
  /** RFQ_MAKER_QUOTE_STATE_REJECTED - venue or validation refused; reason set */
  RFQ_MAKER_QUOTE_STATE_REJECTED = 5,
  /** RFQ_MAKER_QUOTE_STATE_NOT_FILLED - RFQ traded with someone else / execution failed */
  RFQ_MAKER_QUOTE_STATE_NOT_FILLED = 6,
  UNRECOGNIZED = -1,
}

export function rfqMakerQuoteStateFromJSON(object: any): RfqMakerQuoteState {
  switch (object) {
    case 0:
    case 'RFQ_MAKER_QUOTE_STATE_UNSPECIFIED':
      return RfqMakerQuoteState.RFQ_MAKER_QUOTE_STATE_UNSPECIFIED
    case 1:
    case 'RFQ_MAKER_QUOTE_STATE_OPEN':
      return RfqMakerQuoteState.RFQ_MAKER_QUOTE_STATE_OPEN
    case 2:
    case 'RFQ_MAKER_QUOTE_STATE_FILLED':
      return RfqMakerQuoteState.RFQ_MAKER_QUOTE_STATE_FILLED
    case 3:
    case 'RFQ_MAKER_QUOTE_STATE_CANCELLED':
      return RfqMakerQuoteState.RFQ_MAKER_QUOTE_STATE_CANCELLED
    case 4:
    case 'RFQ_MAKER_QUOTE_STATE_EXPIRED':
      return RfqMakerQuoteState.RFQ_MAKER_QUOTE_STATE_EXPIRED
    case 5:
    case 'RFQ_MAKER_QUOTE_STATE_REJECTED':
      return RfqMakerQuoteState.RFQ_MAKER_QUOTE_STATE_REJECTED
    case 6:
    case 'RFQ_MAKER_QUOTE_STATE_NOT_FILLED':
      return RfqMakerQuoteState.RFQ_MAKER_QUOTE_STATE_NOT_FILLED
    case -1:
    case 'UNRECOGNIZED':
    default:
      return RfqMakerQuoteState.UNRECOGNIZED
  }
}

export function rfqMakerQuoteStateToJSON(object: RfqMakerQuoteState): string {
  switch (object) {
    case RfqMakerQuoteState.RFQ_MAKER_QUOTE_STATE_UNSPECIFIED:
      return 'RFQ_MAKER_QUOTE_STATE_UNSPECIFIED'
    case RfqMakerQuoteState.RFQ_MAKER_QUOTE_STATE_OPEN:
      return 'RFQ_MAKER_QUOTE_STATE_OPEN'
    case RfqMakerQuoteState.RFQ_MAKER_QUOTE_STATE_FILLED:
      return 'RFQ_MAKER_QUOTE_STATE_FILLED'
    case RfqMakerQuoteState.RFQ_MAKER_QUOTE_STATE_CANCELLED:
      return 'RFQ_MAKER_QUOTE_STATE_CANCELLED'
    case RfqMakerQuoteState.RFQ_MAKER_QUOTE_STATE_EXPIRED:
      return 'RFQ_MAKER_QUOTE_STATE_EXPIRED'
    case RfqMakerQuoteState.RFQ_MAKER_QUOTE_STATE_REJECTED:
      return 'RFQ_MAKER_QUOTE_STATE_REJECTED'
    case RfqMakerQuoteState.RFQ_MAKER_QUOTE_STATE_NOT_FILLED:
      return 'RFQ_MAKER_QUOTE_STATE_NOT_FILLED'
    case RfqMakerQuoteState.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * One leg of an RFQ structure. Amount is venue-native sizing (see
 * reference_algo_fill_unit_semantics: inverse perps = USD, linear/options = base).
 */
export interface RfqLeg {
  /** normalized symbol; venue resolves native name */
  symbol: string
  /** Decimal string */
  amount: string
  side: OrderSide
}

/** Optional single hedge leg. Requires a price (Deribit hedge is fixed-price). */
export interface RfqHedgeLeg {
  symbol: string
  amount: string
  side: OrderSide
  price: string
}

export interface CreateRfqParams {
  accountId: string
  /** server-assigned (public-api manual / algo per attempt) */
  rfqId: string
  /** count limit validated venue-side (Deribit: 20) */
  legs: RfqLeg[]
  hedge?: RfqHedgeLeg | undefined
  /** venue-native aliases; empty = all makers */
  makerIds: string[]
  /** false (default) = anonymous, >=5 makers enforced */
  disclosed: boolean
  correlationId?: string | undefined
}

export interface CancelRfqParams {
  accountId: string
  rfqId: string
  correlationId?: string | undefined
  network?: RfqNetwork | undefined
}

export interface AcceptRfqQuoteParams {
  accountId: string
  rfqId: string
  /** OrderX quote handle from RfqQuote.quote_id */
  quoteId: string
  /** package price the user/algo saw; venue rejects on mismatch */
  price: string
  correlationId?: string | undefined
  /** Absent == Deribit, preserving every existing caller. */
  network?: RfqNetwork | undefined
}

export interface RfqQuote {
  /** OrderX handle for this displayed quote observation */
  quoteId: string
  /** package price */
  price: string
  amount: string
  /** Deribit can return multiple makers / ANONYMOUS */
  makerAliases: string[]
  expiresAtMs?: string | undefined
  /** duplicated from bids/asks for persistence rows */
  side: RfqQuoteSide
  /** present only when venue exposes one to takers */
  venueQuoteId?: string | undefined
  executionInstruction: RfqQuoteExecutionInstruction
  lastUpdateTimestampMs?: string | undefined
}

/** Stream payload on account_stream.{account_id}.ACCOUNT_DATA_STREAM_TYPE_RFQS */
export interface RfqUpdate {
  accountId: string
  /** OrderX id */
  rfqId: string
  /** audit / debugging */
  venueRfqId: string
  tradeVenue: TradeVenue
  state: RfqState
  createdAtMs: string
  expiresAtMs: string
  /** per-leg amounts (venue normalizes ratio model) */
  legs: RfqLeg[]
  hedge?: RfqHedgeLeg | undefined
  /** makers buying the structure */
  bids: RfqQuote[]
  /** makers selling it — these execute the structure as defined */
  asks: RfqQuote[]
  minTradeAmount: string
  /** package amount basis (for ratio/mark math) */
  amount: string
  /**
   * Monotonic venue-side update stamp (ms). Set by the venue on EVERY emit —
   * including reconnect / request_data re-emits, where it carries the RFQ's
   * last state-change time (NOT wall-clock) so db-writer DEDUP collapses re-emits.
   * Designated-timestamp source for the {env}_rfqs table.
   */
  updatedAtMs: string
  /** Absent/0 == Deribit-native, for every frame minted before this field existed. */
  rfqNetwork: RfqNetwork
  /**
   * Executed package price (Decimal string, can be negative on a spread), set by
   * the venue on its FILLED frame: Deribit's amount-weighted average over the
   * fill's trades, Paradigm's cleared trade price, Derive's executed quote price.
   * Not `RfqAccept.price`, which on Paradigm is only the requested price.
   * GetRfqHistory carries it onto every row it reports as FILLED. Unset when the
   * venue sent no price (and on fills recorded before it existed).
   */
  filledPrice?: string | undefined
}

export interface RfqUpdateList {
  updates: RfqUpdate[]
}

/**
 * Venue-confirmed acceptance of a displayed quote. Emitted by the trade-venue
 * service when `accept_block_rfq` succeeds, so analytics can attribute the
 * accepted price/quote exactly. Rides the account RFQ stream; db-writer
 * persists it as a `kind=ACCEPT` row in {env}_rfq_events.
 */
export interface RfqAccept {
  accountId: string
  rfqId: string
  /** OrderX quote handle the taker lifted */
  quoteId: string
  venueQuoteId?: string | undefined
  /** confirmed package price (Decimal string) */
  price: string
  /** ASK for a structure execution */
  side: RfqQuoteSide
  acceptedAtMs: string
  /**
   * Unlike RfqUpdate, this message carries no trade_venue field — resolve the
   * venue from account_id first. 0 means Deribit-native only once the venue
   * is known to be Deribit; on any other venue (e.g. Derive) it means "not
   * applicable", not Deribit.
   */
  rfqNetwork: RfqNetwork
}

export interface AutoApprove {
  /** within % of package mark */
  markOffsetPercent?: string | undefined
  /** within absolute value of package mark */
  markOffsetValue?: string | undefined
  /** at-or-better than this package price */
  limitPrice?: string | undefined
}

/** both optional + combinable; absent = until filled/cancelled */
export interface AutoRetry {
  maxRetries?: number | undefined
  retryUntilMs?: string | undefined
}

/** An RFQ another taker raised, as this account sees it as a maker. */
export interface RfqMakerRfq {
  accountId: string
  /**
   * `{TRADE_VENUE}:{RFQ_NETWORK}:{venue_rfq_id}` using the proto enum names,
   * e.g. "TRADE_VENUE_DERIBIT:RFQ_NETWORK_DERIBIT:12345" (spec Decision 7).
   * Native Bybit / Derive / Lighter RFQs use RFQ_NETWORK_UNSPECIFIED.
   */
  rfqId: string
  venueRfqId: string
  /** settlement venue */
  tradeVenue: TradeVenue
  rfqNetwork: RfqNetwork
  state: RfqState
  createdAtMs: string
  expiresAtMs: string
  /**
   * Legs as the TAKER requested them (side = taker's leg direction; a maker
   * quote mirrors them). Lighter: one leg, side UNSPECIFIED (venue redacts it).
   */
  legs: RfqLeg[]
  /** package amount (Decimal string) */
  amount: string
  minTradeAmount: string
  /** Deribit taker_rating; Derive fill_rate */
  takerRating?: string | undefined
  /** Deribit taker (disclosed) / Paradigm desk / Bybit deskCode */
  taker?: string | undefined
  disclosed: boolean
  /** Venue state-change time; stable across re-emits (taker invariant). */
  updatedAtMs: string
  /** post-trade package price where the venue reveals it */
  tradePrice?: string | undefined
  /**
   * Every hedge leg, in venue order; empty when unhedged. Only Bybit RFQs
   * carry more than one. Never quoted — the venue fills hedges at the RFQ's
   * own price — but shown so the maker sees the whole package.
   */
  hedges: RfqHedgeLeg[]
  /**
   * Size in the quote currency (Decimal string) for an RFQ the taker sized
   * in quote rather than base; `amount` is then empty. Lighter only (USDC).
   */
  quoteAmount?: string | undefined
}

/** Snapshot or delta of incoming RFQs for one account. */
export interface RfqMakerRfqList {
  accountId: string
  rfqs: RfqMakerRfq[]
  /**
   * Set when the venue refused the maker subscription for this account
   * (not approved as a maker). rfqs is then empty (spec N6 / Decision 2).
   */
  makerUnavailableReason?: string | undefined
  tradeVenue: TradeVenue
  /**
   * The name takers see this account quote under on the venue (Paradigm
   * desk name, ...). Unset when the venue shows makers no name, or it is
   * not known yet; a frame without it does not clear one seen earlier.
   */
  makerDisplayName?: string | undefined
  /**
   * The RFQ network this list, its maker_unavailable_reason and
   * maker_display_name belong to. One account can be a maker on two
   * networks at once (a Deribit account linked to a Paradigm desk gets
   * RFQ_NETWORK_DERIBIT and RFQ_NETWORK_PARADIGM lists), so clients key
   * maker availability and display name by (account_id, rfq_network).
   * UNSPECIFIED = the venue's own RFQ system (Bybit, Derive, Lighter),
   * as on RfqMakerRfq.rfq_network.
   */
  rfqNetwork: RfqNetwork
}

/** A quote this account sent. */
export interface RfqMakerQuote {
  accountId: string
  /** OrderX, 30 lowercase alnum (spec N1) */
  quoteId: string
  venueQuoteId?: string | undefined
  /** RfqMakerRfq.rfq_id */
  rfqId: string
  rfqNetwork: RfqNetwork
  tradeVenue: TradeVenue
  /** BID = we buy the structure as the taker defined it */
  side: RfqQuoteSide
  /** realised package price sent to the venue */
  price: string
  /** package price the user typed (differs after tick rounding, N2) */
  requestedPrice?: string | undefined
  amount: string
  filledAmount: string
  state: RfqMakerQuoteState
  /** REJECTED / NOT_FILLED / CANCELLED reason */
  reason?: string | undefined
  createdAtMs: string
  /** venue state-change time; stable across re-emits */
  updatedAtMs: string
  /** Bybit (<=120 s, N3); Lighter order_expiry; else RFQ expiry */
  expiresAtMs?: string | undefined
}

export interface RfqMakerQuoteList {
  accountId: string
  quotes: RfqMakerQuote[]
}

/** Commands (execution.{TRADE_VENUE}.{account_id}; Paradigm: the paradigm service subject). */
export interface SendRfqMakerQuoteParams {
  accountId: string
  /** RfqMakerRfq.rfq_id */
  rfqId: string
  /** minted by public-api */
  quoteId: string
  side: RfqQuoteSide
  /** package price per unit (Decimal string) */
  price: string
  correlationId?: string | undefined
}

export interface CancelRfqMakerQuoteParams {
  accountId: string
  quoteId: string
  correlationId?: string | undefined
  /** maker rfq id; routes the cancel exactly like Send */
  rfqId: string
}

function createBaseRfqLeg(): RfqLeg {
  return { symbol: '', amount: '', side: 0 }
}

export const RfqLeg: MessageFns<RfqLeg> = {
  encode(message: RfqLeg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.amount !== '') {
      writer.uint32(18).string(message.amount)
    }
    if (message.side !== 0) {
      writer.uint32(24).int32(message.side)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RfqLeg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRfqLeg()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.amount = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.side = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RfqLeg {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      amount: isSet(object.amount) ? globalThis.String(object.amount) : '',
      side: isSet(object.side) ? orderSideFromJSON(object.side) : 0,
    }
  },

  toJSON(message: RfqLeg): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.amount !== '') {
      obj.amount = message.amount
    }
    if (message.side !== 0) {
      obj.side = orderSideToJSON(message.side)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RfqLeg>, I>>(base?: I): RfqLeg {
    return RfqLeg.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RfqLeg>, I>>(object: I): RfqLeg {
    const message = createBaseRfqLeg()
    message.symbol = object.symbol ?? ''
    message.amount = object.amount ?? ''
    message.side = object.side ?? 0
    return message
  },
}

function createBaseRfqHedgeLeg(): RfqHedgeLeg {
  return { symbol: '', amount: '', side: 0, price: '' }
}

export const RfqHedgeLeg: MessageFns<RfqHedgeLeg> = {
  encode(message: RfqHedgeLeg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.amount !== '') {
      writer.uint32(18).string(message.amount)
    }
    if (message.side !== 0) {
      writer.uint32(24).int32(message.side)
    }
    if (message.price !== '') {
      writer.uint32(34).string(message.price)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RfqHedgeLeg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRfqHedgeLeg()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.amount = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.side = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.price = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RfqHedgeLeg {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      amount: isSet(object.amount) ? globalThis.String(object.amount) : '',
      side: isSet(object.side) ? orderSideFromJSON(object.side) : 0,
      price: isSet(object.price) ? globalThis.String(object.price) : '',
    }
  },

  toJSON(message: RfqHedgeLeg): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.amount !== '') {
      obj.amount = message.amount
    }
    if (message.side !== 0) {
      obj.side = orderSideToJSON(message.side)
    }
    if (message.price !== '') {
      obj.price = message.price
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RfqHedgeLeg>, I>>(base?: I): RfqHedgeLeg {
    return RfqHedgeLeg.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RfqHedgeLeg>, I>>(object: I): RfqHedgeLeg {
    const message = createBaseRfqHedgeLeg()
    message.symbol = object.symbol ?? ''
    message.amount = object.amount ?? ''
    message.side = object.side ?? 0
    message.price = object.price ?? ''
    return message
  },
}

function createBaseCreateRfqParams(): CreateRfqParams {
  return {
    accountId: '',
    rfqId: '',
    legs: [],
    hedge: undefined,
    makerIds: [],
    disclosed: false,
    correlationId: undefined,
  }
}

export const CreateRfqParams: MessageFns<CreateRfqParams> = {
  encode(message: CreateRfqParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.rfqId !== '') {
      writer.uint32(18).string(message.rfqId)
    }
    for (const v of message.legs) {
      RfqLeg.encode(v!, writer.uint32(26).fork()).join()
    }
    if (message.hedge !== undefined) {
      RfqHedgeLeg.encode(message.hedge, writer.uint32(34).fork()).join()
    }
    for (const v of message.makerIds) {
      writer.uint32(42).string(v!)
    }
    if (message.disclosed !== false) {
      writer.uint32(48).bool(message.disclosed)
    }
    if (message.correlationId !== undefined) {
      writer.uint32(58).string(message.correlationId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateRfqParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCreateRfqParams()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.rfqId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.legs.push(RfqLeg.decode(reader, reader.uint32()))
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.hedge = RfqHedgeLeg.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.makerIds.push(reader.string())
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.disclosed = reader.bool()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.correlationId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CreateRfqParams {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      rfqId: isSet(object.rfqId)
        ? globalThis.String(object.rfqId)
        : isSet(object.rfq_id)
          ? globalThis.String(object.rfq_id)
          : '',
      legs: globalThis.Array.isArray(object?.legs)
        ? object.legs.map((e: any) => RfqLeg.fromJSON(e))
        : [],
      hedge: isSet(object.hedge) ? RfqHedgeLeg.fromJSON(object.hedge) : undefined,
      makerIds: globalThis.Array.isArray(object?.makerIds)
        ? object.makerIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.maker_ids)
          ? object.maker_ids.map((e: any) => globalThis.String(e))
          : [],
      disclosed: isSet(object.disclosed) ? globalThis.Boolean(object.disclosed) : false,
      correlationId: isSet(object.correlationId)
        ? globalThis.String(object.correlationId)
        : isSet(object.correlation_id)
          ? globalThis.String(object.correlation_id)
          : undefined,
    }
  },

  toJSON(message: CreateRfqParams): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.rfqId !== '') {
      obj.rfqId = message.rfqId
    }
    if (message.legs?.length) {
      obj.legs = message.legs.map((e) => RfqLeg.toJSON(e))
    }
    if (message.hedge !== undefined) {
      obj.hedge = RfqHedgeLeg.toJSON(message.hedge)
    }
    if (message.makerIds?.length) {
      obj.makerIds = message.makerIds
    }
    if (message.disclosed !== false) {
      obj.disclosed = message.disclosed
    }
    if (message.correlationId !== undefined) {
      obj.correlationId = message.correlationId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CreateRfqParams>, I>>(base?: I): CreateRfqParams {
    return CreateRfqParams.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CreateRfqParams>, I>>(object: I): CreateRfqParams {
    const message = createBaseCreateRfqParams()
    message.accountId = object.accountId ?? ''
    message.rfqId = object.rfqId ?? ''
    message.legs = object.legs?.map((e) => RfqLeg.fromPartial(e)) || []
    message.hedge =
      object.hedge !== undefined && object.hedge !== null
        ? RfqHedgeLeg.fromPartial(object.hedge)
        : undefined
    message.makerIds = object.makerIds?.map((e) => e) || []
    message.disclosed = object.disclosed ?? false
    message.correlationId = object.correlationId ?? undefined
    return message
  },
}

function createBaseCancelRfqParams(): CancelRfqParams {
  return { accountId: '', rfqId: '', correlationId: undefined, network: undefined }
}

export const CancelRfqParams: MessageFns<CancelRfqParams> = {
  encode(message: CancelRfqParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.rfqId !== '') {
      writer.uint32(18).string(message.rfqId)
    }
    if (message.correlationId !== undefined) {
      writer.uint32(26).string(message.correlationId)
    }
    if (message.network !== undefined) {
      writer.uint32(32).int32(message.network)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CancelRfqParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCancelRfqParams()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.rfqId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.correlationId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.network = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CancelRfqParams {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      rfqId: isSet(object.rfqId)
        ? globalThis.String(object.rfqId)
        : isSet(object.rfq_id)
          ? globalThis.String(object.rfq_id)
          : '',
      correlationId: isSet(object.correlationId)
        ? globalThis.String(object.correlationId)
        : isSet(object.correlation_id)
          ? globalThis.String(object.correlation_id)
          : undefined,
      network: isSet(object.network) ? rfqNetworkFromJSON(object.network) : undefined,
    }
  },

  toJSON(message: CancelRfqParams): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.rfqId !== '') {
      obj.rfqId = message.rfqId
    }
    if (message.correlationId !== undefined) {
      obj.correlationId = message.correlationId
    }
    if (message.network !== undefined) {
      obj.network = rfqNetworkToJSON(message.network)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CancelRfqParams>, I>>(base?: I): CancelRfqParams {
    return CancelRfqParams.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CancelRfqParams>, I>>(object: I): CancelRfqParams {
    const message = createBaseCancelRfqParams()
    message.accountId = object.accountId ?? ''
    message.rfqId = object.rfqId ?? ''
    message.correlationId = object.correlationId ?? undefined
    message.network = object.network ?? undefined
    return message
  },
}

function createBaseAcceptRfqQuoteParams(): AcceptRfqQuoteParams {
  return {
    accountId: '',
    rfqId: '',
    quoteId: '',
    price: '',
    correlationId: undefined,
    network: undefined,
  }
}

export const AcceptRfqQuoteParams: MessageFns<AcceptRfqQuoteParams> = {
  encode(message: AcceptRfqQuoteParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.rfqId !== '') {
      writer.uint32(18).string(message.rfqId)
    }
    if (message.quoteId !== '') {
      writer.uint32(26).string(message.quoteId)
    }
    if (message.price !== '') {
      writer.uint32(34).string(message.price)
    }
    if (message.correlationId !== undefined) {
      writer.uint32(42).string(message.correlationId)
    }
    if (message.network !== undefined) {
      writer.uint32(48).int32(message.network)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AcceptRfqQuoteParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAcceptRfqQuoteParams()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.rfqId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.quoteId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.price = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.correlationId = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.network = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AcceptRfqQuoteParams {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      rfqId: isSet(object.rfqId)
        ? globalThis.String(object.rfqId)
        : isSet(object.rfq_id)
          ? globalThis.String(object.rfq_id)
          : '',
      quoteId: isSet(object.quoteId)
        ? globalThis.String(object.quoteId)
        : isSet(object.quote_id)
          ? globalThis.String(object.quote_id)
          : '',
      price: isSet(object.price) ? globalThis.String(object.price) : '',
      correlationId: isSet(object.correlationId)
        ? globalThis.String(object.correlationId)
        : isSet(object.correlation_id)
          ? globalThis.String(object.correlation_id)
          : undefined,
      network: isSet(object.network) ? rfqNetworkFromJSON(object.network) : undefined,
    }
  },

  toJSON(message: AcceptRfqQuoteParams): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.rfqId !== '') {
      obj.rfqId = message.rfqId
    }
    if (message.quoteId !== '') {
      obj.quoteId = message.quoteId
    }
    if (message.price !== '') {
      obj.price = message.price
    }
    if (message.correlationId !== undefined) {
      obj.correlationId = message.correlationId
    }
    if (message.network !== undefined) {
      obj.network = rfqNetworkToJSON(message.network)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AcceptRfqQuoteParams>, I>>(base?: I): AcceptRfqQuoteParams {
    return AcceptRfqQuoteParams.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AcceptRfqQuoteParams>, I>>(
    object: I
  ): AcceptRfqQuoteParams {
    const message = createBaseAcceptRfqQuoteParams()
    message.accountId = object.accountId ?? ''
    message.rfqId = object.rfqId ?? ''
    message.quoteId = object.quoteId ?? ''
    message.price = object.price ?? ''
    message.correlationId = object.correlationId ?? undefined
    message.network = object.network ?? undefined
    return message
  },
}

function createBaseRfqQuote(): RfqQuote {
  return {
    quoteId: '',
    price: '',
    amount: '',
    makerAliases: [],
    expiresAtMs: undefined,
    side: 0,
    venueQuoteId: undefined,
    executionInstruction: 0,
    lastUpdateTimestampMs: undefined,
  }
}

export const RfqQuote: MessageFns<RfqQuote> = {
  encode(message: RfqQuote, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.quoteId !== '') {
      writer.uint32(10).string(message.quoteId)
    }
    if (message.price !== '') {
      writer.uint32(18).string(message.price)
    }
    if (message.amount !== '') {
      writer.uint32(26).string(message.amount)
    }
    for (const v of message.makerAliases) {
      writer.uint32(34).string(v!)
    }
    if (message.expiresAtMs !== undefined) {
      writer.uint32(40).int64(message.expiresAtMs)
    }
    if (message.side !== 0) {
      writer.uint32(48).int32(message.side)
    }
    if (message.venueQuoteId !== undefined) {
      writer.uint32(58).string(message.venueQuoteId)
    }
    if (message.executionInstruction !== 0) {
      writer.uint32(64).int32(message.executionInstruction)
    }
    if (message.lastUpdateTimestampMs !== undefined) {
      writer.uint32(72).int64(message.lastUpdateTimestampMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RfqQuote {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRfqQuote()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.quoteId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.price = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.amount = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.makerAliases.push(reader.string())
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.expiresAtMs = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.side = reader.int32() as any
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.venueQuoteId = reader.string()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.executionInstruction = reader.int32() as any
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.lastUpdateTimestampMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RfqQuote {
    return {
      quoteId: isSet(object.quoteId)
        ? globalThis.String(object.quoteId)
        : isSet(object.quote_id)
          ? globalThis.String(object.quote_id)
          : '',
      price: isSet(object.price) ? globalThis.String(object.price) : '',
      amount: isSet(object.amount) ? globalThis.String(object.amount) : '',
      makerAliases: globalThis.Array.isArray(object?.makerAliases)
        ? object.makerAliases.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.maker_aliases)
          ? object.maker_aliases.map((e: any) => globalThis.String(e))
          : [],
      expiresAtMs: isSet(object.expiresAtMs)
        ? globalThis.String(object.expiresAtMs)
        : isSet(object.expires_at_ms)
          ? globalThis.String(object.expires_at_ms)
          : undefined,
      side: isSet(object.side) ? rfqQuoteSideFromJSON(object.side) : 0,
      venueQuoteId: isSet(object.venueQuoteId)
        ? globalThis.String(object.venueQuoteId)
        : isSet(object.venue_quote_id)
          ? globalThis.String(object.venue_quote_id)
          : undefined,
      executionInstruction: isSet(object.executionInstruction)
        ? rfqQuoteExecutionInstructionFromJSON(object.executionInstruction)
        : isSet(object.execution_instruction)
          ? rfqQuoteExecutionInstructionFromJSON(object.execution_instruction)
          : 0,
      lastUpdateTimestampMs: isSet(object.lastUpdateTimestampMs)
        ? globalThis.String(object.lastUpdateTimestampMs)
        : isSet(object.last_update_timestamp_ms)
          ? globalThis.String(object.last_update_timestamp_ms)
          : undefined,
    }
  },

  toJSON(message: RfqQuote): unknown {
    const obj: any = {}
    if (message.quoteId !== '') {
      obj.quoteId = message.quoteId
    }
    if (message.price !== '') {
      obj.price = message.price
    }
    if (message.amount !== '') {
      obj.amount = message.amount
    }
    if (message.makerAliases?.length) {
      obj.makerAliases = message.makerAliases
    }
    if (message.expiresAtMs !== undefined) {
      obj.expiresAtMs = message.expiresAtMs
    }
    if (message.side !== 0) {
      obj.side = rfqQuoteSideToJSON(message.side)
    }
    if (message.venueQuoteId !== undefined) {
      obj.venueQuoteId = message.venueQuoteId
    }
    if (message.executionInstruction !== 0) {
      obj.executionInstruction = rfqQuoteExecutionInstructionToJSON(message.executionInstruction)
    }
    if (message.lastUpdateTimestampMs !== undefined) {
      obj.lastUpdateTimestampMs = message.lastUpdateTimestampMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RfqQuote>, I>>(base?: I): RfqQuote {
    return RfqQuote.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RfqQuote>, I>>(object: I): RfqQuote {
    const message = createBaseRfqQuote()
    message.quoteId = object.quoteId ?? ''
    message.price = object.price ?? ''
    message.amount = object.amount ?? ''
    message.makerAliases = object.makerAliases?.map((e) => e) || []
    message.expiresAtMs = object.expiresAtMs ?? undefined
    message.side = object.side ?? 0
    message.venueQuoteId = object.venueQuoteId ?? undefined
    message.executionInstruction = object.executionInstruction ?? 0
    message.lastUpdateTimestampMs = object.lastUpdateTimestampMs ?? undefined
    return message
  },
}

function createBaseRfqUpdate(): RfqUpdate {
  return {
    accountId: '',
    rfqId: '',
    venueRfqId: '',
    tradeVenue: 0,
    state: 0,
    createdAtMs: '0',
    expiresAtMs: '0',
    legs: [],
    hedge: undefined,
    bids: [],
    asks: [],
    minTradeAmount: '',
    amount: '',
    updatedAtMs: '0',
    rfqNetwork: 0,
    filledPrice: undefined,
  }
}

export const RfqUpdate: MessageFns<RfqUpdate> = {
  encode(message: RfqUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.rfqId !== '') {
      writer.uint32(18).string(message.rfqId)
    }
    if (message.venueRfqId !== '') {
      writer.uint32(26).string(message.venueRfqId)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(32).int32(message.tradeVenue)
    }
    if (message.state !== 0) {
      writer.uint32(40).int32(message.state)
    }
    if (message.createdAtMs !== '0') {
      writer.uint32(48).int64(message.createdAtMs)
    }
    if (message.expiresAtMs !== '0') {
      writer.uint32(56).int64(message.expiresAtMs)
    }
    for (const v of message.legs) {
      RfqLeg.encode(v!, writer.uint32(66).fork()).join()
    }
    if (message.hedge !== undefined) {
      RfqHedgeLeg.encode(message.hedge, writer.uint32(74).fork()).join()
    }
    for (const v of message.bids) {
      RfqQuote.encode(v!, writer.uint32(82).fork()).join()
    }
    for (const v of message.asks) {
      RfqQuote.encode(v!, writer.uint32(90).fork()).join()
    }
    if (message.minTradeAmount !== '') {
      writer.uint32(98).string(message.minTradeAmount)
    }
    if (message.amount !== '') {
      writer.uint32(106).string(message.amount)
    }
    if (message.updatedAtMs !== '0') {
      writer.uint32(112).int64(message.updatedAtMs)
    }
    if (message.rfqNetwork !== 0) {
      writer.uint32(120).int32(message.rfqNetwork)
    }
    if (message.filledPrice !== undefined) {
      writer.uint32(130).string(message.filledPrice)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RfqUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRfqUpdate()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.rfqId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.venueRfqId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.state = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.createdAtMs = reader.int64().toString()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.expiresAtMs = reader.int64().toString()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.legs.push(RfqLeg.decode(reader, reader.uint32()))
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.hedge = RfqHedgeLeg.decode(reader, reader.uint32())
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.bids.push(RfqQuote.decode(reader, reader.uint32()))
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.asks.push(RfqQuote.decode(reader, reader.uint32()))
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.minTradeAmount = reader.string()
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.amount = reader.string()
          continue
        }
        case 14: {
          if (tag !== 112) {
            break
          }

          message.updatedAtMs = reader.int64().toString()
          continue
        }
        case 15: {
          if (tag !== 120) {
            break
          }

          message.rfqNetwork = reader.int32() as any
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.filledPrice = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RfqUpdate {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      rfqId: isSet(object.rfqId)
        ? globalThis.String(object.rfqId)
        : isSet(object.rfq_id)
          ? globalThis.String(object.rfq_id)
          : '',
      venueRfqId: isSet(object.venueRfqId)
        ? globalThis.String(object.venueRfqId)
        : isSet(object.venue_rfq_id)
          ? globalThis.String(object.venue_rfq_id)
          : '',
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      state: isSet(object.state) ? rfqStateFromJSON(object.state) : 0,
      createdAtMs: isSet(object.createdAtMs)
        ? globalThis.String(object.createdAtMs)
        : isSet(object.created_at_ms)
          ? globalThis.String(object.created_at_ms)
          : '0',
      expiresAtMs: isSet(object.expiresAtMs)
        ? globalThis.String(object.expiresAtMs)
        : isSet(object.expires_at_ms)
          ? globalThis.String(object.expires_at_ms)
          : '0',
      legs: globalThis.Array.isArray(object?.legs)
        ? object.legs.map((e: any) => RfqLeg.fromJSON(e))
        : [],
      hedge: isSet(object.hedge) ? RfqHedgeLeg.fromJSON(object.hedge) : undefined,
      bids: globalThis.Array.isArray(object?.bids)
        ? object.bids.map((e: any) => RfqQuote.fromJSON(e))
        : [],
      asks: globalThis.Array.isArray(object?.asks)
        ? object.asks.map((e: any) => RfqQuote.fromJSON(e))
        : [],
      minTradeAmount: isSet(object.minTradeAmount)
        ? globalThis.String(object.minTradeAmount)
        : isSet(object.min_trade_amount)
          ? globalThis.String(object.min_trade_amount)
          : '',
      amount: isSet(object.amount) ? globalThis.String(object.amount) : '',
      updatedAtMs: isSet(object.updatedAtMs)
        ? globalThis.String(object.updatedAtMs)
        : isSet(object.updated_at_ms)
          ? globalThis.String(object.updated_at_ms)
          : '0',
      rfqNetwork: isSet(object.rfqNetwork)
        ? rfqNetworkFromJSON(object.rfqNetwork)
        : isSet(object.rfq_network)
          ? rfqNetworkFromJSON(object.rfq_network)
          : 0,
      filledPrice: isSet(object.filledPrice)
        ? globalThis.String(object.filledPrice)
        : isSet(object.filled_price)
          ? globalThis.String(object.filled_price)
          : undefined,
    }
  },

  toJSON(message: RfqUpdate): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.rfqId !== '') {
      obj.rfqId = message.rfqId
    }
    if (message.venueRfqId !== '') {
      obj.venueRfqId = message.venueRfqId
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.state !== 0) {
      obj.state = rfqStateToJSON(message.state)
    }
    if (message.createdAtMs !== '0') {
      obj.createdAtMs = message.createdAtMs
    }
    if (message.expiresAtMs !== '0') {
      obj.expiresAtMs = message.expiresAtMs
    }
    if (message.legs?.length) {
      obj.legs = message.legs.map((e) => RfqLeg.toJSON(e))
    }
    if (message.hedge !== undefined) {
      obj.hedge = RfqHedgeLeg.toJSON(message.hedge)
    }
    if (message.bids?.length) {
      obj.bids = message.bids.map((e) => RfqQuote.toJSON(e))
    }
    if (message.asks?.length) {
      obj.asks = message.asks.map((e) => RfqQuote.toJSON(e))
    }
    if (message.minTradeAmount !== '') {
      obj.minTradeAmount = message.minTradeAmount
    }
    if (message.amount !== '') {
      obj.amount = message.amount
    }
    if (message.updatedAtMs !== '0') {
      obj.updatedAtMs = message.updatedAtMs
    }
    if (message.rfqNetwork !== 0) {
      obj.rfqNetwork = rfqNetworkToJSON(message.rfqNetwork)
    }
    if (message.filledPrice !== undefined) {
      obj.filledPrice = message.filledPrice
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RfqUpdate>, I>>(base?: I): RfqUpdate {
    return RfqUpdate.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RfqUpdate>, I>>(object: I): RfqUpdate {
    const message = createBaseRfqUpdate()
    message.accountId = object.accountId ?? ''
    message.rfqId = object.rfqId ?? ''
    message.venueRfqId = object.venueRfqId ?? ''
    message.tradeVenue = object.tradeVenue ?? 0
    message.state = object.state ?? 0
    message.createdAtMs = object.createdAtMs ?? '0'
    message.expiresAtMs = object.expiresAtMs ?? '0'
    message.legs = object.legs?.map((e) => RfqLeg.fromPartial(e)) || []
    message.hedge =
      object.hedge !== undefined && object.hedge !== null
        ? RfqHedgeLeg.fromPartial(object.hedge)
        : undefined
    message.bids = object.bids?.map((e) => RfqQuote.fromPartial(e)) || []
    message.asks = object.asks?.map((e) => RfqQuote.fromPartial(e)) || []
    message.minTradeAmount = object.minTradeAmount ?? ''
    message.amount = object.amount ?? ''
    message.updatedAtMs = object.updatedAtMs ?? '0'
    message.rfqNetwork = object.rfqNetwork ?? 0
    message.filledPrice = object.filledPrice ?? undefined
    return message
  },
}

function createBaseRfqUpdateList(): RfqUpdateList {
  return { updates: [] }
}

export const RfqUpdateList: MessageFns<RfqUpdateList> = {
  encode(message: RfqUpdateList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.updates) {
      RfqUpdate.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RfqUpdateList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRfqUpdateList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.updates.push(RfqUpdate.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RfqUpdateList {
    return {
      updates: globalThis.Array.isArray(object?.updates)
        ? object.updates.map((e: any) => RfqUpdate.fromJSON(e))
        : [],
    }
  },

  toJSON(message: RfqUpdateList): unknown {
    const obj: any = {}
    if (message.updates?.length) {
      obj.updates = message.updates.map((e) => RfqUpdate.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RfqUpdateList>, I>>(base?: I): RfqUpdateList {
    return RfqUpdateList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RfqUpdateList>, I>>(object: I): RfqUpdateList {
    const message = createBaseRfqUpdateList()
    message.updates = object.updates?.map((e) => RfqUpdate.fromPartial(e)) || []
    return message
  },
}

function createBaseRfqAccept(): RfqAccept {
  return {
    accountId: '',
    rfqId: '',
    quoteId: '',
    venueQuoteId: undefined,
    price: '',
    side: 0,
    acceptedAtMs: '0',
    rfqNetwork: 0,
  }
}

export const RfqAccept: MessageFns<RfqAccept> = {
  encode(message: RfqAccept, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.rfqId !== '') {
      writer.uint32(18).string(message.rfqId)
    }
    if (message.quoteId !== '') {
      writer.uint32(26).string(message.quoteId)
    }
    if (message.venueQuoteId !== undefined) {
      writer.uint32(34).string(message.venueQuoteId)
    }
    if (message.price !== '') {
      writer.uint32(42).string(message.price)
    }
    if (message.side !== 0) {
      writer.uint32(48).int32(message.side)
    }
    if (message.acceptedAtMs !== '0') {
      writer.uint32(56).int64(message.acceptedAtMs)
    }
    if (message.rfqNetwork !== 0) {
      writer.uint32(64).int32(message.rfqNetwork)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RfqAccept {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRfqAccept()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.rfqId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.quoteId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.venueQuoteId = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.price = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.side = reader.int32() as any
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.acceptedAtMs = reader.int64().toString()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.rfqNetwork = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RfqAccept {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      rfqId: isSet(object.rfqId)
        ? globalThis.String(object.rfqId)
        : isSet(object.rfq_id)
          ? globalThis.String(object.rfq_id)
          : '',
      quoteId: isSet(object.quoteId)
        ? globalThis.String(object.quoteId)
        : isSet(object.quote_id)
          ? globalThis.String(object.quote_id)
          : '',
      venueQuoteId: isSet(object.venueQuoteId)
        ? globalThis.String(object.venueQuoteId)
        : isSet(object.venue_quote_id)
          ? globalThis.String(object.venue_quote_id)
          : undefined,
      price: isSet(object.price) ? globalThis.String(object.price) : '',
      side: isSet(object.side) ? rfqQuoteSideFromJSON(object.side) : 0,
      acceptedAtMs: isSet(object.acceptedAtMs)
        ? globalThis.String(object.acceptedAtMs)
        : isSet(object.accepted_at_ms)
          ? globalThis.String(object.accepted_at_ms)
          : '0',
      rfqNetwork: isSet(object.rfqNetwork)
        ? rfqNetworkFromJSON(object.rfqNetwork)
        : isSet(object.rfq_network)
          ? rfqNetworkFromJSON(object.rfq_network)
          : 0,
    }
  },

  toJSON(message: RfqAccept): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.rfqId !== '') {
      obj.rfqId = message.rfqId
    }
    if (message.quoteId !== '') {
      obj.quoteId = message.quoteId
    }
    if (message.venueQuoteId !== undefined) {
      obj.venueQuoteId = message.venueQuoteId
    }
    if (message.price !== '') {
      obj.price = message.price
    }
    if (message.side !== 0) {
      obj.side = rfqQuoteSideToJSON(message.side)
    }
    if (message.acceptedAtMs !== '0') {
      obj.acceptedAtMs = message.acceptedAtMs
    }
    if (message.rfqNetwork !== 0) {
      obj.rfqNetwork = rfqNetworkToJSON(message.rfqNetwork)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RfqAccept>, I>>(base?: I): RfqAccept {
    return RfqAccept.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RfqAccept>, I>>(object: I): RfqAccept {
    const message = createBaseRfqAccept()
    message.accountId = object.accountId ?? ''
    message.rfqId = object.rfqId ?? ''
    message.quoteId = object.quoteId ?? ''
    message.venueQuoteId = object.venueQuoteId ?? undefined
    message.price = object.price ?? ''
    message.side = object.side ?? 0
    message.acceptedAtMs = object.acceptedAtMs ?? '0'
    message.rfqNetwork = object.rfqNetwork ?? 0
    return message
  },
}

function createBaseAutoApprove(): AutoApprove {
  return { markOffsetPercent: undefined, markOffsetValue: undefined, limitPrice: undefined }
}

export const AutoApprove: MessageFns<AutoApprove> = {
  encode(message: AutoApprove, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.markOffsetPercent !== undefined) {
      writer.uint32(10).string(message.markOffsetPercent)
    }
    if (message.markOffsetValue !== undefined) {
      writer.uint32(18).string(message.markOffsetValue)
    }
    if (message.limitPrice !== undefined) {
      writer.uint32(26).string(message.limitPrice)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AutoApprove {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAutoApprove()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.markOffsetPercent = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.markOffsetValue = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.limitPrice = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AutoApprove {
    return {
      markOffsetPercent: isSet(object.markOffsetPercent)
        ? globalThis.String(object.markOffsetPercent)
        : isSet(object.mark_offset_percent)
          ? globalThis.String(object.mark_offset_percent)
          : undefined,
      markOffsetValue: isSet(object.markOffsetValue)
        ? globalThis.String(object.markOffsetValue)
        : isSet(object.mark_offset_value)
          ? globalThis.String(object.mark_offset_value)
          : undefined,
      limitPrice: isSet(object.limitPrice)
        ? globalThis.String(object.limitPrice)
        : isSet(object.limit_price)
          ? globalThis.String(object.limit_price)
          : undefined,
    }
  },

  toJSON(message: AutoApprove): unknown {
    const obj: any = {}
    if (message.markOffsetPercent !== undefined) {
      obj.markOffsetPercent = message.markOffsetPercent
    }
    if (message.markOffsetValue !== undefined) {
      obj.markOffsetValue = message.markOffsetValue
    }
    if (message.limitPrice !== undefined) {
      obj.limitPrice = message.limitPrice
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AutoApprove>, I>>(base?: I): AutoApprove {
    return AutoApprove.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AutoApprove>, I>>(object: I): AutoApprove {
    const message = createBaseAutoApprove()
    message.markOffsetPercent = object.markOffsetPercent ?? undefined
    message.markOffsetValue = object.markOffsetValue ?? undefined
    message.limitPrice = object.limitPrice ?? undefined
    return message
  },
}

function createBaseAutoRetry(): AutoRetry {
  return { maxRetries: undefined, retryUntilMs: undefined }
}

export const AutoRetry: MessageFns<AutoRetry> = {
  encode(message: AutoRetry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.maxRetries !== undefined) {
      writer.uint32(8).int32(message.maxRetries)
    }
    if (message.retryUntilMs !== undefined) {
      writer.uint32(16).int64(message.retryUntilMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AutoRetry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAutoRetry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.maxRetries = reader.int32()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.retryUntilMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AutoRetry {
    return {
      maxRetries: isSet(object.maxRetries)
        ? globalThis.Number(object.maxRetries)
        : isSet(object.max_retries)
          ? globalThis.Number(object.max_retries)
          : undefined,
      retryUntilMs: isSet(object.retryUntilMs)
        ? globalThis.String(object.retryUntilMs)
        : isSet(object.retry_until_ms)
          ? globalThis.String(object.retry_until_ms)
          : undefined,
    }
  },

  toJSON(message: AutoRetry): unknown {
    const obj: any = {}
    if (message.maxRetries !== undefined) {
      obj.maxRetries = Math.round(message.maxRetries)
    }
    if (message.retryUntilMs !== undefined) {
      obj.retryUntilMs = message.retryUntilMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AutoRetry>, I>>(base?: I): AutoRetry {
    return AutoRetry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AutoRetry>, I>>(object: I): AutoRetry {
    const message = createBaseAutoRetry()
    message.maxRetries = object.maxRetries ?? undefined
    message.retryUntilMs = object.retryUntilMs ?? undefined
    return message
  },
}

function createBaseRfqMakerRfq(): RfqMakerRfq {
  return {
    accountId: '',
    rfqId: '',
    venueRfqId: '',
    tradeVenue: 0,
    rfqNetwork: 0,
    state: 0,
    createdAtMs: '0',
    expiresAtMs: '0',
    legs: [],
    amount: '',
    minTradeAmount: '',
    takerRating: undefined,
    taker: undefined,
    disclosed: false,
    updatedAtMs: '0',
    tradePrice: undefined,
    hedges: [],
    quoteAmount: undefined,
  }
}

export const RfqMakerRfq: MessageFns<RfqMakerRfq> = {
  encode(message: RfqMakerRfq, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.rfqId !== '') {
      writer.uint32(18).string(message.rfqId)
    }
    if (message.venueRfqId !== '') {
      writer.uint32(26).string(message.venueRfqId)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(32).int32(message.tradeVenue)
    }
    if (message.rfqNetwork !== 0) {
      writer.uint32(40).int32(message.rfqNetwork)
    }
    if (message.state !== 0) {
      writer.uint32(48).int32(message.state)
    }
    if (message.createdAtMs !== '0') {
      writer.uint32(56).int64(message.createdAtMs)
    }
    if (message.expiresAtMs !== '0') {
      writer.uint32(64).int64(message.expiresAtMs)
    }
    for (const v of message.legs) {
      RfqLeg.encode(v!, writer.uint32(74).fork()).join()
    }
    if (message.amount !== '') {
      writer.uint32(90).string(message.amount)
    }
    if (message.minTradeAmount !== '') {
      writer.uint32(98).string(message.minTradeAmount)
    }
    if (message.takerRating !== undefined) {
      writer.uint32(106).string(message.takerRating)
    }
    if (message.taker !== undefined) {
      writer.uint32(114).string(message.taker)
    }
    if (message.disclosed !== false) {
      writer.uint32(120).bool(message.disclosed)
    }
    if (message.updatedAtMs !== '0') {
      writer.uint32(128).int64(message.updatedAtMs)
    }
    if (message.tradePrice !== undefined) {
      writer.uint32(138).string(message.tradePrice)
    }
    for (const v of message.hedges) {
      RfqHedgeLeg.encode(v!, writer.uint32(146).fork()).join()
    }
    if (message.quoteAmount !== undefined) {
      writer.uint32(154).string(message.quoteAmount)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RfqMakerRfq {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRfqMakerRfq()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.rfqId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.venueRfqId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.rfqNetwork = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.state = reader.int32() as any
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.createdAtMs = reader.int64().toString()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.expiresAtMs = reader.int64().toString()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.legs.push(RfqLeg.decode(reader, reader.uint32()))
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.amount = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.minTradeAmount = reader.string()
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.takerRating = reader.string()
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.taker = reader.string()
          continue
        }
        case 15: {
          if (tag !== 120) {
            break
          }

          message.disclosed = reader.bool()
          continue
        }
        case 16: {
          if (tag !== 128) {
            break
          }

          message.updatedAtMs = reader.int64().toString()
          continue
        }
        case 17: {
          if (tag !== 138) {
            break
          }

          message.tradePrice = reader.string()
          continue
        }
        case 18: {
          if (tag !== 146) {
            break
          }

          message.hedges.push(RfqHedgeLeg.decode(reader, reader.uint32()))
          continue
        }
        case 19: {
          if (tag !== 154) {
            break
          }

          message.quoteAmount = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RfqMakerRfq {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      rfqId: isSet(object.rfqId)
        ? globalThis.String(object.rfqId)
        : isSet(object.rfq_id)
          ? globalThis.String(object.rfq_id)
          : '',
      venueRfqId: isSet(object.venueRfqId)
        ? globalThis.String(object.venueRfqId)
        : isSet(object.venue_rfq_id)
          ? globalThis.String(object.venue_rfq_id)
          : '',
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      rfqNetwork: isSet(object.rfqNetwork)
        ? rfqNetworkFromJSON(object.rfqNetwork)
        : isSet(object.rfq_network)
          ? rfqNetworkFromJSON(object.rfq_network)
          : 0,
      state: isSet(object.state) ? rfqStateFromJSON(object.state) : 0,
      createdAtMs: isSet(object.createdAtMs)
        ? globalThis.String(object.createdAtMs)
        : isSet(object.created_at_ms)
          ? globalThis.String(object.created_at_ms)
          : '0',
      expiresAtMs: isSet(object.expiresAtMs)
        ? globalThis.String(object.expiresAtMs)
        : isSet(object.expires_at_ms)
          ? globalThis.String(object.expires_at_ms)
          : '0',
      legs: globalThis.Array.isArray(object?.legs)
        ? object.legs.map((e: any) => RfqLeg.fromJSON(e))
        : [],
      amount: isSet(object.amount) ? globalThis.String(object.amount) : '',
      minTradeAmount: isSet(object.minTradeAmount)
        ? globalThis.String(object.minTradeAmount)
        : isSet(object.min_trade_amount)
          ? globalThis.String(object.min_trade_amount)
          : '',
      takerRating: isSet(object.takerRating)
        ? globalThis.String(object.takerRating)
        : isSet(object.taker_rating)
          ? globalThis.String(object.taker_rating)
          : undefined,
      taker: isSet(object.taker) ? globalThis.String(object.taker) : undefined,
      disclosed: isSet(object.disclosed) ? globalThis.Boolean(object.disclosed) : false,
      updatedAtMs: isSet(object.updatedAtMs)
        ? globalThis.String(object.updatedAtMs)
        : isSet(object.updated_at_ms)
          ? globalThis.String(object.updated_at_ms)
          : '0',
      tradePrice: isSet(object.tradePrice)
        ? globalThis.String(object.tradePrice)
        : isSet(object.trade_price)
          ? globalThis.String(object.trade_price)
          : undefined,
      hedges: globalThis.Array.isArray(object?.hedges)
        ? object.hedges.map((e: any) => RfqHedgeLeg.fromJSON(e))
        : [],
      quoteAmount: isSet(object.quoteAmount)
        ? globalThis.String(object.quoteAmount)
        : isSet(object.quote_amount)
          ? globalThis.String(object.quote_amount)
          : undefined,
    }
  },

  toJSON(message: RfqMakerRfq): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.rfqId !== '') {
      obj.rfqId = message.rfqId
    }
    if (message.venueRfqId !== '') {
      obj.venueRfqId = message.venueRfqId
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.rfqNetwork !== 0) {
      obj.rfqNetwork = rfqNetworkToJSON(message.rfqNetwork)
    }
    if (message.state !== 0) {
      obj.state = rfqStateToJSON(message.state)
    }
    if (message.createdAtMs !== '0') {
      obj.createdAtMs = message.createdAtMs
    }
    if (message.expiresAtMs !== '0') {
      obj.expiresAtMs = message.expiresAtMs
    }
    if (message.legs?.length) {
      obj.legs = message.legs.map((e) => RfqLeg.toJSON(e))
    }
    if (message.amount !== '') {
      obj.amount = message.amount
    }
    if (message.minTradeAmount !== '') {
      obj.minTradeAmount = message.minTradeAmount
    }
    if (message.takerRating !== undefined) {
      obj.takerRating = message.takerRating
    }
    if (message.taker !== undefined) {
      obj.taker = message.taker
    }
    if (message.disclosed !== false) {
      obj.disclosed = message.disclosed
    }
    if (message.updatedAtMs !== '0') {
      obj.updatedAtMs = message.updatedAtMs
    }
    if (message.tradePrice !== undefined) {
      obj.tradePrice = message.tradePrice
    }
    if (message.hedges?.length) {
      obj.hedges = message.hedges.map((e) => RfqHedgeLeg.toJSON(e))
    }
    if (message.quoteAmount !== undefined) {
      obj.quoteAmount = message.quoteAmount
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RfqMakerRfq>, I>>(base?: I): RfqMakerRfq {
    return RfqMakerRfq.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RfqMakerRfq>, I>>(object: I): RfqMakerRfq {
    const message = createBaseRfqMakerRfq()
    message.accountId = object.accountId ?? ''
    message.rfqId = object.rfqId ?? ''
    message.venueRfqId = object.venueRfqId ?? ''
    message.tradeVenue = object.tradeVenue ?? 0
    message.rfqNetwork = object.rfqNetwork ?? 0
    message.state = object.state ?? 0
    message.createdAtMs = object.createdAtMs ?? '0'
    message.expiresAtMs = object.expiresAtMs ?? '0'
    message.legs = object.legs?.map((e) => RfqLeg.fromPartial(e)) || []
    message.amount = object.amount ?? ''
    message.minTradeAmount = object.minTradeAmount ?? ''
    message.takerRating = object.takerRating ?? undefined
    message.taker = object.taker ?? undefined
    message.disclosed = object.disclosed ?? false
    message.updatedAtMs = object.updatedAtMs ?? '0'
    message.tradePrice = object.tradePrice ?? undefined
    message.hedges = object.hedges?.map((e) => RfqHedgeLeg.fromPartial(e)) || []
    message.quoteAmount = object.quoteAmount ?? undefined
    return message
  },
}

function createBaseRfqMakerRfqList(): RfqMakerRfqList {
  return {
    accountId: '',
    rfqs: [],
    makerUnavailableReason: undefined,
    tradeVenue: 0,
    makerDisplayName: undefined,
    rfqNetwork: 0,
  }
}

export const RfqMakerRfqList: MessageFns<RfqMakerRfqList> = {
  encode(message: RfqMakerRfqList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    for (const v of message.rfqs) {
      RfqMakerRfq.encode(v!, writer.uint32(18).fork()).join()
    }
    if (message.makerUnavailableReason !== undefined) {
      writer.uint32(26).string(message.makerUnavailableReason)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(32).int32(message.tradeVenue)
    }
    if (message.makerDisplayName !== undefined) {
      writer.uint32(42).string(message.makerDisplayName)
    }
    if (message.rfqNetwork !== 0) {
      writer.uint32(48).int32(message.rfqNetwork)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RfqMakerRfqList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRfqMakerRfqList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.rfqs.push(RfqMakerRfq.decode(reader, reader.uint32()))
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.makerUnavailableReason = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.makerDisplayName = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.rfqNetwork = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RfqMakerRfqList {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      rfqs: globalThis.Array.isArray(object?.rfqs)
        ? object.rfqs.map((e: any) => RfqMakerRfq.fromJSON(e))
        : [],
      makerUnavailableReason: isSet(object.makerUnavailableReason)
        ? globalThis.String(object.makerUnavailableReason)
        : isSet(object.maker_unavailable_reason)
          ? globalThis.String(object.maker_unavailable_reason)
          : undefined,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      makerDisplayName: isSet(object.makerDisplayName)
        ? globalThis.String(object.makerDisplayName)
        : isSet(object.maker_display_name)
          ? globalThis.String(object.maker_display_name)
          : undefined,
      rfqNetwork: isSet(object.rfqNetwork)
        ? rfqNetworkFromJSON(object.rfqNetwork)
        : isSet(object.rfq_network)
          ? rfqNetworkFromJSON(object.rfq_network)
          : 0,
    }
  },

  toJSON(message: RfqMakerRfqList): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.rfqs?.length) {
      obj.rfqs = message.rfqs.map((e) => RfqMakerRfq.toJSON(e))
    }
    if (message.makerUnavailableReason !== undefined) {
      obj.makerUnavailableReason = message.makerUnavailableReason
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.makerDisplayName !== undefined) {
      obj.makerDisplayName = message.makerDisplayName
    }
    if (message.rfqNetwork !== 0) {
      obj.rfqNetwork = rfqNetworkToJSON(message.rfqNetwork)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RfqMakerRfqList>, I>>(base?: I): RfqMakerRfqList {
    return RfqMakerRfqList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RfqMakerRfqList>, I>>(object: I): RfqMakerRfqList {
    const message = createBaseRfqMakerRfqList()
    message.accountId = object.accountId ?? ''
    message.rfqs = object.rfqs?.map((e) => RfqMakerRfq.fromPartial(e)) || []
    message.makerUnavailableReason = object.makerUnavailableReason ?? undefined
    message.tradeVenue = object.tradeVenue ?? 0
    message.makerDisplayName = object.makerDisplayName ?? undefined
    message.rfqNetwork = object.rfqNetwork ?? 0
    return message
  },
}

function createBaseRfqMakerQuote(): RfqMakerQuote {
  return {
    accountId: '',
    quoteId: '',
    venueQuoteId: undefined,
    rfqId: '',
    rfqNetwork: 0,
    tradeVenue: 0,
    side: 0,
    price: '',
    requestedPrice: undefined,
    amount: '',
    filledAmount: '',
    state: 0,
    reason: undefined,
    createdAtMs: '0',
    updatedAtMs: '0',
    expiresAtMs: undefined,
  }
}

export const RfqMakerQuote: MessageFns<RfqMakerQuote> = {
  encode(message: RfqMakerQuote, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.quoteId !== '') {
      writer.uint32(18).string(message.quoteId)
    }
    if (message.venueQuoteId !== undefined) {
      writer.uint32(26).string(message.venueQuoteId)
    }
    if (message.rfqId !== '') {
      writer.uint32(34).string(message.rfqId)
    }
    if (message.rfqNetwork !== 0) {
      writer.uint32(40).int32(message.rfqNetwork)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(48).int32(message.tradeVenue)
    }
    if (message.side !== 0) {
      writer.uint32(56).int32(message.side)
    }
    if (message.price !== '') {
      writer.uint32(66).string(message.price)
    }
    if (message.requestedPrice !== undefined) {
      writer.uint32(74).string(message.requestedPrice)
    }
    if (message.amount !== '') {
      writer.uint32(82).string(message.amount)
    }
    if (message.filledAmount !== '') {
      writer.uint32(90).string(message.filledAmount)
    }
    if (message.state !== 0) {
      writer.uint32(96).int32(message.state)
    }
    if (message.reason !== undefined) {
      writer.uint32(106).string(message.reason)
    }
    if (message.createdAtMs !== '0') {
      writer.uint32(112).int64(message.createdAtMs)
    }
    if (message.updatedAtMs !== '0') {
      writer.uint32(120).int64(message.updatedAtMs)
    }
    if (message.expiresAtMs !== undefined) {
      writer.uint32(128).int64(message.expiresAtMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RfqMakerQuote {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRfqMakerQuote()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.quoteId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.venueQuoteId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.rfqId = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.rfqNetwork = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.side = reader.int32() as any
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.price = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.requestedPrice = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.amount = reader.string()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.filledAmount = reader.string()
          continue
        }
        case 12: {
          if (tag !== 96) {
            break
          }

          message.state = reader.int32() as any
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.reason = reader.string()
          continue
        }
        case 14: {
          if (tag !== 112) {
            break
          }

          message.createdAtMs = reader.int64().toString()
          continue
        }
        case 15: {
          if (tag !== 120) {
            break
          }

          message.updatedAtMs = reader.int64().toString()
          continue
        }
        case 16: {
          if (tag !== 128) {
            break
          }

          message.expiresAtMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RfqMakerQuote {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      quoteId: isSet(object.quoteId)
        ? globalThis.String(object.quoteId)
        : isSet(object.quote_id)
          ? globalThis.String(object.quote_id)
          : '',
      venueQuoteId: isSet(object.venueQuoteId)
        ? globalThis.String(object.venueQuoteId)
        : isSet(object.venue_quote_id)
          ? globalThis.String(object.venue_quote_id)
          : undefined,
      rfqId: isSet(object.rfqId)
        ? globalThis.String(object.rfqId)
        : isSet(object.rfq_id)
          ? globalThis.String(object.rfq_id)
          : '',
      rfqNetwork: isSet(object.rfqNetwork)
        ? rfqNetworkFromJSON(object.rfqNetwork)
        : isSet(object.rfq_network)
          ? rfqNetworkFromJSON(object.rfq_network)
          : 0,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      side: isSet(object.side) ? rfqQuoteSideFromJSON(object.side) : 0,
      price: isSet(object.price) ? globalThis.String(object.price) : '',
      requestedPrice: isSet(object.requestedPrice)
        ? globalThis.String(object.requestedPrice)
        : isSet(object.requested_price)
          ? globalThis.String(object.requested_price)
          : undefined,
      amount: isSet(object.amount) ? globalThis.String(object.amount) : '',
      filledAmount: isSet(object.filledAmount)
        ? globalThis.String(object.filledAmount)
        : isSet(object.filled_amount)
          ? globalThis.String(object.filled_amount)
          : '',
      state: isSet(object.state) ? rfqMakerQuoteStateFromJSON(object.state) : 0,
      reason: isSet(object.reason) ? globalThis.String(object.reason) : undefined,
      createdAtMs: isSet(object.createdAtMs)
        ? globalThis.String(object.createdAtMs)
        : isSet(object.created_at_ms)
          ? globalThis.String(object.created_at_ms)
          : '0',
      updatedAtMs: isSet(object.updatedAtMs)
        ? globalThis.String(object.updatedAtMs)
        : isSet(object.updated_at_ms)
          ? globalThis.String(object.updated_at_ms)
          : '0',
      expiresAtMs: isSet(object.expiresAtMs)
        ? globalThis.String(object.expiresAtMs)
        : isSet(object.expires_at_ms)
          ? globalThis.String(object.expires_at_ms)
          : undefined,
    }
  },

  toJSON(message: RfqMakerQuote): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.quoteId !== '') {
      obj.quoteId = message.quoteId
    }
    if (message.venueQuoteId !== undefined) {
      obj.venueQuoteId = message.venueQuoteId
    }
    if (message.rfqId !== '') {
      obj.rfqId = message.rfqId
    }
    if (message.rfqNetwork !== 0) {
      obj.rfqNetwork = rfqNetworkToJSON(message.rfqNetwork)
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.side !== 0) {
      obj.side = rfqQuoteSideToJSON(message.side)
    }
    if (message.price !== '') {
      obj.price = message.price
    }
    if (message.requestedPrice !== undefined) {
      obj.requestedPrice = message.requestedPrice
    }
    if (message.amount !== '') {
      obj.amount = message.amount
    }
    if (message.filledAmount !== '') {
      obj.filledAmount = message.filledAmount
    }
    if (message.state !== 0) {
      obj.state = rfqMakerQuoteStateToJSON(message.state)
    }
    if (message.reason !== undefined) {
      obj.reason = message.reason
    }
    if (message.createdAtMs !== '0') {
      obj.createdAtMs = message.createdAtMs
    }
    if (message.updatedAtMs !== '0') {
      obj.updatedAtMs = message.updatedAtMs
    }
    if (message.expiresAtMs !== undefined) {
      obj.expiresAtMs = message.expiresAtMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RfqMakerQuote>, I>>(base?: I): RfqMakerQuote {
    return RfqMakerQuote.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RfqMakerQuote>, I>>(object: I): RfqMakerQuote {
    const message = createBaseRfqMakerQuote()
    message.accountId = object.accountId ?? ''
    message.quoteId = object.quoteId ?? ''
    message.venueQuoteId = object.venueQuoteId ?? undefined
    message.rfqId = object.rfqId ?? ''
    message.rfqNetwork = object.rfqNetwork ?? 0
    message.tradeVenue = object.tradeVenue ?? 0
    message.side = object.side ?? 0
    message.price = object.price ?? ''
    message.requestedPrice = object.requestedPrice ?? undefined
    message.amount = object.amount ?? ''
    message.filledAmount = object.filledAmount ?? ''
    message.state = object.state ?? 0
    message.reason = object.reason ?? undefined
    message.createdAtMs = object.createdAtMs ?? '0'
    message.updatedAtMs = object.updatedAtMs ?? '0'
    message.expiresAtMs = object.expiresAtMs ?? undefined
    return message
  },
}

function createBaseRfqMakerQuoteList(): RfqMakerQuoteList {
  return { accountId: '', quotes: [] }
}

export const RfqMakerQuoteList: MessageFns<RfqMakerQuoteList> = {
  encode(message: RfqMakerQuoteList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    for (const v of message.quotes) {
      RfqMakerQuote.encode(v!, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RfqMakerQuoteList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRfqMakerQuoteList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.quotes.push(RfqMakerQuote.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RfqMakerQuoteList {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      quotes: globalThis.Array.isArray(object?.quotes)
        ? object.quotes.map((e: any) => RfqMakerQuote.fromJSON(e))
        : [],
    }
  },

  toJSON(message: RfqMakerQuoteList): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.quotes?.length) {
      obj.quotes = message.quotes.map((e) => RfqMakerQuote.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RfqMakerQuoteList>, I>>(base?: I): RfqMakerQuoteList {
    return RfqMakerQuoteList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RfqMakerQuoteList>, I>>(object: I): RfqMakerQuoteList {
    const message = createBaseRfqMakerQuoteList()
    message.accountId = object.accountId ?? ''
    message.quotes = object.quotes?.map((e) => RfqMakerQuote.fromPartial(e)) || []
    return message
  },
}

function createBaseSendRfqMakerQuoteParams(): SendRfqMakerQuoteParams {
  return { accountId: '', rfqId: '', quoteId: '', side: 0, price: '', correlationId: undefined }
}

export const SendRfqMakerQuoteParams: MessageFns<SendRfqMakerQuoteParams> = {
  encode(
    message: SendRfqMakerQuoteParams,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.rfqId !== '') {
      writer.uint32(18).string(message.rfqId)
    }
    if (message.quoteId !== '') {
      writer.uint32(26).string(message.quoteId)
    }
    if (message.side !== 0) {
      writer.uint32(32).int32(message.side)
    }
    if (message.price !== '') {
      writer.uint32(42).string(message.price)
    }
    if (message.correlationId !== undefined) {
      writer.uint32(50).string(message.correlationId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SendRfqMakerQuoteParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSendRfqMakerQuoteParams()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.rfqId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.quoteId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.side = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.price = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.correlationId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SendRfqMakerQuoteParams {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      rfqId: isSet(object.rfqId)
        ? globalThis.String(object.rfqId)
        : isSet(object.rfq_id)
          ? globalThis.String(object.rfq_id)
          : '',
      quoteId: isSet(object.quoteId)
        ? globalThis.String(object.quoteId)
        : isSet(object.quote_id)
          ? globalThis.String(object.quote_id)
          : '',
      side: isSet(object.side) ? rfqQuoteSideFromJSON(object.side) : 0,
      price: isSet(object.price) ? globalThis.String(object.price) : '',
      correlationId: isSet(object.correlationId)
        ? globalThis.String(object.correlationId)
        : isSet(object.correlation_id)
          ? globalThis.String(object.correlation_id)
          : undefined,
    }
  },

  toJSON(message: SendRfqMakerQuoteParams): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.rfqId !== '') {
      obj.rfqId = message.rfqId
    }
    if (message.quoteId !== '') {
      obj.quoteId = message.quoteId
    }
    if (message.side !== 0) {
      obj.side = rfqQuoteSideToJSON(message.side)
    }
    if (message.price !== '') {
      obj.price = message.price
    }
    if (message.correlationId !== undefined) {
      obj.correlationId = message.correlationId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SendRfqMakerQuoteParams>, I>>(
    base?: I
  ): SendRfqMakerQuoteParams {
    return SendRfqMakerQuoteParams.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SendRfqMakerQuoteParams>, I>>(
    object: I
  ): SendRfqMakerQuoteParams {
    const message = createBaseSendRfqMakerQuoteParams()
    message.accountId = object.accountId ?? ''
    message.rfqId = object.rfqId ?? ''
    message.quoteId = object.quoteId ?? ''
    message.side = object.side ?? 0
    message.price = object.price ?? ''
    message.correlationId = object.correlationId ?? undefined
    return message
  },
}

function createBaseCancelRfqMakerQuoteParams(): CancelRfqMakerQuoteParams {
  return { accountId: '', quoteId: '', correlationId: undefined, rfqId: '' }
}

export const CancelRfqMakerQuoteParams: MessageFns<CancelRfqMakerQuoteParams> = {
  encode(
    message: CancelRfqMakerQuoteParams,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.quoteId !== '') {
      writer.uint32(18).string(message.quoteId)
    }
    if (message.correlationId !== undefined) {
      writer.uint32(26).string(message.correlationId)
    }
    if (message.rfqId !== '') {
      writer.uint32(34).string(message.rfqId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CancelRfqMakerQuoteParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCancelRfqMakerQuoteParams()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.quoteId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.correlationId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.rfqId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CancelRfqMakerQuoteParams {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      quoteId: isSet(object.quoteId)
        ? globalThis.String(object.quoteId)
        : isSet(object.quote_id)
          ? globalThis.String(object.quote_id)
          : '',
      correlationId: isSet(object.correlationId)
        ? globalThis.String(object.correlationId)
        : isSet(object.correlation_id)
          ? globalThis.String(object.correlation_id)
          : undefined,
      rfqId: isSet(object.rfqId)
        ? globalThis.String(object.rfqId)
        : isSet(object.rfq_id)
          ? globalThis.String(object.rfq_id)
          : '',
    }
  },

  toJSON(message: CancelRfqMakerQuoteParams): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.quoteId !== '') {
      obj.quoteId = message.quoteId
    }
    if (message.correlationId !== undefined) {
      obj.correlationId = message.correlationId
    }
    if (message.rfqId !== '') {
      obj.rfqId = message.rfqId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CancelRfqMakerQuoteParams>, I>>(
    base?: I
  ): CancelRfqMakerQuoteParams {
    return CancelRfqMakerQuoteParams.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CancelRfqMakerQuoteParams>, I>>(
    object: I
  ): CancelRfqMakerQuoteParams {
    const message = createBaseCancelRfqMakerQuoteParams()
    message.accountId = object.accountId ?? ''
    message.quoteId = object.quoteId ?? ''
    message.correlationId = object.correlationId ?? undefined
    message.rfqId = object.rfqId ?? ''
    return message
  },
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends globalThis.Array<infer U>
    ? globalThis.Array<DeepPartial<U>>
    : T extends ReadonlyArray<infer U>
      ? ReadonlyArray<DeepPartial<U>>
      : T extends {}
        ? { [K in keyof T]?: DeepPartial<T[K]> }
        : Partial<T>

type KeysOfUnion<T> = T extends T ? keyof T : never
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never }

function isSet(value: any): boolean {
  return value !== null && value !== undefined
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter
  decode(input: BinaryReader | Uint8Array, length?: number): T
  fromJSON(object: any): T
  toJSON(message: T): unknown
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T
}
